import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { ResponseModelInterfaceStatic } from "../../response-model-interface";
import { DataAdjustment } from "./data-responses/data-adjustment";
import { DataPercentiles } from "./data-responses/data-percentiles";
import { DataPoints } from "./data-responses/data-points";
import { DataPrediction } from "./data-responses/data-prediction";
import { DataResponse } from "./data-responses/data-response";
import { Status } from "./status";

@staticImplements<ResponseModelInterfaceStatic>()
export class Response
{
    public constructor(
        public requestId: string,
        public status: Status,
        public type: string,
        public data: DataResponse,
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): Response
    {
        const requestId = elem.firstChildByTag("requestId").value();
        const status = Status.makeFromXml(elem.firstChildByTag("requestStatus"));
        const type = elem.firstChildByTag("requestType").enumValue(Response.RequestType);
        let data: DataResponse|null = null;

        switch (type) {
            case Response.RequestType.ADJUSTMENT:
                data = DataAdjustment.makeFromXml(elem.firstChildByTag("dataAdjustment"));
                break;

            case Response.RequestType.PREDICTION:
                data = DataPrediction.makeFromXml(elem.firstChildByTag("dataPrediction"));
                break;

            case Response.RequestType.SINGLE_POINTS:
                data = DataPoints.makeFromXml(elem.firstChildByTag("dataPoints"));
                break;

            case Response.RequestType.PERCENTILES:
                data = DataPercentiles.makeFromXml(elem.firstChildByTag("dataPercentiles"));
                break;

            default:
                throw new Error(`Unsupported requestType "${type}"`);
        }

        return new this(requestId, status, type, data);
    }
}

export namespace Response
{
    export enum RequestType
    {
        ADJUSTMENT = "adjustment",
        PREDICTION = "prediction",
        SINGLE_POINTS = "singlePoints",
        PERCENTILES = "percentiles",
    }
}
